<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <EmployeeForm
      v-if="!isLoading"
      :employeeData="employeeData"
      :imageSrc="imageSrc"
      :submitName="$t('edit')"
      v-on:addOrUpdateEmployee="updateEmployee"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS, BASE_URL } from "@/utils/constants";
import DEFAULT_IMG_CLIENT from "@/assets/images/employee.svg";
// import { date2slash, date2dash, timeTo12, timeTo24 } from "@/utils/functions";
import EmployeeForm from "@/components/employees/EmployeeForm.vue";
import Employee from "@/models/employees/Employee";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "EmployeeEdit",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    EmployeeForm,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      imageSrc: DEFAULT_IMG_CLIENT,
      employeeData: new Employee(),
      employeeToken: this.$route.params.employeeToken,
    };
  },
  methods: {
    async getEmployeeDetails() {
      this.isLoading = true;
      this.employeeData.employeeToken = this.employeeToken;
      try {
        let response = await this.employeeData.getEmployeeDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.employeeData.fillData(response.data.employeeData);
          let ccName = response.data.employeeData.employeeCountryCodeName;
          let cc = response.data.employeeData.employeeCountryCode;
          this.employeeData.employeeCCWithCCName =
            ccName === "" || cc === "" ? "" : ccName + " " + cc;

          this.employeeData.image = "";
          if (this.employeeData.employeeImagePath) {
            this.imageSrc = BASE_URL + this.employeeData.employeeImagePath;
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.employeeData = null;
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.employeeData = null;
      }
      this.isLoading = false;
    },
    async updateEmployee() {
      this.isLoading = true;
      try {
        let response = await this.employeeData.addOrUpdateEmployee(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push("/employees");
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getEmployeeDetails();
  },
};
</script>

<style scoped lang="scss"></style>
